import { GetApplicationsQueryResult } from '@sdir/httpclient/lib/clients/aps/application';

/** Hvilken motor søknaden skal vurderes av. */
export type ValidationEngine = 'certreq' | 'legacy';

export const CERTREQ_ENGINE: ValidationEngine = 'certreq';

/**
 * Leser `validationEngine` fra søknaden. Feltet er lagt til i backend, men finnes
 * ennå ikke i den genererte klienttypen — derfor leses det via en egen struktur.
 * Ukjent/manglende verdi behandles som `legacy`, altså den gamle kvalifikasjonssiden.
 */
export const readValidationEngine = (
  application?: GetApplicationsQueryResult | null
): ValidationEngine => {
  const raw = (application as { validationEngine?: string } | null | undefined)?.validationEngine;
  if (typeof raw === 'string' && raw.toLowerCase() === CERTREQ_ENGINE) return CERTREQ_ENGINE;
  return 'legacy';
};
